<template>
  <div class="user-page partner-page-container">
    <div class="uk-width-1-1">
      <PageHeader :title="partnerTitle" icon="uil-heart" />

      <div class="partner-page">
        <template v-if="isLoading">
          <PartnerCardSkeleton v-for="n in 3" :key="'skeleton_' + n"/>
        </template>

        <template v-else-if="activePartners.length > 0">
          <PartnerCard v-for="partner in activePartners"
                       :key="partner.id"
                       :partner="partner"
                       :show-status-toggle="false"
                       @connect="partnerRefreshAndOpen"
          />
        </template>

        <div v-else class="partner-empty">
          <i class="uil-heart-break"></i>
          <p>{{ $t('general.no_active_partners') || 'Aktif partner bulunamadı.' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PartnerCard from "@/view/components/card/PartnerCard.vue";
import PartnerCardSkeleton from "@/view/components/card/PartnerCardSkeleton.vue";
import PageHeader from "@/view/components/common/PageHeader.vue";
import axios from "axios";
import widgetMixin from "@/core/mixin/widget.mixin.js";

export default {
  name: "Partner",
  mixins: [widgetMixin],
  components: {
    PartnerCard,
    PartnerCardSkeleton,
    PageHeader
  },
  data() {
    return {
      partners: [],
      isLoading: true
    }
  },
  computed: {
    partnerTitle() {
      const sourceMenu = this.getDashboardMenuItems(this.menuListMixin);
      const menuItem = sourceMenu.find(item => item.type === "solution_partners_apps");
      return this.getLocalizedWidgetTitle(menuItem, this.$t("general.solution_partners_apps"), this.$i18n?.locale);
    },
    activePartners() {
      return this.partners.filter(partner => partner.status === 1);
    }
  },
  methods: {
    getPartnersResult() {
      this.isLoading = true;
      axios
          .get('api/partners')
          .then((result) => {
            this.partners = result.data.data;
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    partnerRefreshAndOpen(partner) {
      this.getPartnersResult();

      setTimeout(() => {
        const url = partner.connect_url || partner.default_url;
        window.open(url, '_blank');
      }, 10);
    },
  },
  async mounted() {
    try {
      await this.getWidgetsMixin();

      if (!this.isSolutionPartnerWidgetActive) {
        await this.$router.push({ path: "/dashboard" });
        return;
      }

      this.getPartnersResult();
    } catch (error) {
      await this.$router.push({ path: "/dashboard" });
    }
  },
}
</script>

<style scoped>
.partner-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.partner-page-container {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.partner-page-container > .uk-width-1-1 {
  min-width: 0;
}

.partner-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  gap: 12px;
  margin: 0 auto;
  padding: 48px 24px;
  text-align: center;
  color: #94a3b8;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.partner-empty i {
  font-size: 48px;
  opacity: 0.4;
}

.partner-empty p {
  font-size: 16px;
  max-width: 100%;
  line-height: 1.5;
  margin: 0;
}

@media (max-width: 480px) {
  .partner-page-container {
    padding-left: 12px;
    padding-right: 12px;
  }

  .partner-page-container :deep(.page-header-block) {
    gap: 8px;
  }

  .partner-page-container :deep(.page-header-block__title) {
    min-width: 0;
    font-size: 18px;
  }

  .partner-page {
    gap: 12px;
  }

  .partner-empty {
    padding: 32px 16px;
  }

  .partner-empty i {
    font-size: 36px;
  }

  .partner-empty p {
    font-size: 14px;
  }
}
</style>
